export default "__VITE_ASSET__BjOQ_Vqt__"